// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CouponSvg from '@rsuite/icon-font/lib/application/Coupon';
var Coupon = createSvgIcon({
  as: CouponSvg,
  ariaLabel: 'coupon',
  category: 'application',
  displayName: 'Coupon'
});
export default Coupon;